// extracted by mini-css-extract-plugin
export var button = "filterTag-module--button--4b808";
export var filterTag = "filterTag-module--filterTag--39489";
export var gold = "filterTag-module--gold--9b0fe";
export var icon = "filterTag-module--icon--d45c1";
export var locked = "filterTag-module--locked--c8550";